var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"email-stats"}},[_c('h2',[_vm._v(_vm._s(_vm.title)+" Stats")]),_vm._v(" "),(_vm.newsletterId)?_c('newsletter-nav',{attrs:{"newsletterId":_vm.newsletterId}}):_vm._e(),_vm._v(" "),(_vm.emailId)?_c('email-nav',{attrs:{"emailId":_vm.emailId}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.stats),function(count,name){return _c('router-link',{key:name,class:_vm.$root.listItemClasses,attrs:{"to":{
        name: _vm.route,
        params: {
          emailId: _vm.emailId,
          newsletterId: _vm.newsletterId,
          status: name
        }
      }}},[_vm._v("\n      "+_vm._s(_vm.statusTitle(name))+" "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(count))])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80d9f960","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailStats.vue
// module id = 1242
// module chunks = 1